import React from "react";
import { Modal } from "react-bootstrap";
import { usePayBonusSharesMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { HoldingIcon } from "../../../../util/Icons";

const ConfirmBonusSharePaymentModal = ({ showConfirmBonusSharePaymentModal, onHide, bonusShareId, symbol, qualificationDate }) => {
    const [
        payBonusShares, // This is the mutation trigger
        {
            isLoading,
        }, // This is the destructured mutation result
    ] = usePayBonusSharesMutation()

    /* Pay Bonus Shares */
    const pay = () => {
        payBonusShares(bonusShareId)
            .unwrap()
            .then(() => {
                cogoToast.success("Bonus Shares Payment Initiated Successfully")
                onHide()
            })
    }

    return (
        <Modal
            show={showConfirmBonusSharePaymentModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <HoldingIcon />
                    </span>
                    Pay Unpaid Bonus Shares
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                <p>Are you sure you want to pay unpaid <strong>{symbol}</strong> bonus shares for <strong>{qualificationDate}</strong></p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isLoading}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={isLoading}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                    onClick={pay}
                >
                    Proceed
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmBonusSharePaymentModal;
